import polyglotI18nProvider from "ra-i18n-polyglot";
import { resolveBrowserLocale } from "react-admin";
import { uk, en, customUkMessages } from "../locales/index.js";
import * as domainMessages from "react-admin-import-csv/lib/i18n/index.js";

const translations = {
  en: { component: { record: "record" }, ...en, ...domainMessages.en },
  uk: {
    component: { record: "record" },
    ...uk,
    ...domainMessages.uk,
    ...customUkMessages,
  },
};

const i18nProvider = polyglotI18nProvider(
  (locale) => (translations[locale] ? translations[locale] : translations.en),
  resolveBrowserLocale(),
  [
    { locale: "en", name: "English" },
    { locale: "uk", name: "Українська" },
  ],
  {
    allowMissing: true,
  }
);

export default i18nProvider;
